/* RESPONSIBLE TEAM: team-data-foundations */
import AppStoreController from './base/appstore';

export default AppStoreController;
